import { atom } from 'recoil';

import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist({
  key: 'giftDeliveryAddress',
  storage: typeof window !== 'undefined' ? localStorage : undefined,
});

/**
 * 일괄배송(Bulk) 최근 배송지 — 주소만 보존.
 * 결제 실패(카드사 실패 등)/새로고침/재진입에도 재입력 부담을 줄이기 위해 마지막 입력값을 기억한다.
 * 주문자 이름/연락처는 member 정보로 자동입력되므로 여기서는 보존하지 않는다.
 */
export interface GiftDeliveryAddressState {
  /** 기본주소 (우편번호 검색 결과) */
  address: string;
  /** 우편번호 */
  postalCode: string;
  /** 상세주소 (동/호수 등) */
  addressDetail?: string;
}

export const giftDeliveryAddressAtom = atom<GiftDeliveryAddressState | null>({
  key: 'giftDeliveryAddressAtom',
  default: null,
  effects_UNSTABLE: [persistAtom],
});
